
import React, { Component } from "react";
import { Progress } from 'antd';
import '../css/widget/widget.progress.css'
class WidgetProgress extends Component {
    constructor (props) {
        super(props);

        this.state = {
        }
    }

    render() {

        const {total, current, percentPosition={ align: 'start', type: 'outer'}, type="line"} = this.props;

        let percent = current / total * 100;

        return (
            <div className="sf-progress sd-progress sg-progress">
                <Progress percent={percent} percentPosition={percentPosition} type={type} format={(percent) => `${current}/${total}`} />
            </div>
        )
    }
}

export default WidgetProgress;